module.exports = __webpack_public_path__ + "src/img/export.63b3ed7d.svg";